// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-spinner{
    display: inline-block;
    width: 30px;
    height: 30px;
    border: 3px solid transparent;
    border-radius: 50%;
    border-top-color: #333;
    animation: spin 1s ease-in-out infinite;
    -webkit-animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
    to { -webkit-transform: rotate(360deg); }
}`, "",{"version":3,"sources":["webpack://./modules/react-components/css/spinner.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,kBAAkB;IAClB,sBAAsB;IACtB,uCAAuC;IACvC,+CAA+C;AACnD;;AAEA;IACI,KAAK,iCAAiC,EAAE;AAC5C","sourcesContent":[".react-spinner{\n    display: inline-block;\n    width: 30px;\n    height: 30px;\n    border: 3px solid transparent;\n    border-radius: 50%;\n    border-top-color: #333;\n    animation: spin 1s ease-in-out infinite;\n    -webkit-animation: spin 1s ease-in-out infinite;\n}\n\n@keyframes spin {\n    to { -webkit-transform: rotate(360deg); }\n}\n@-webkit-keyframes spin {\n    to { -webkit-transform: rotate(360deg); }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
